import React, { FC, useEffect } from 'react'
import Helmet from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from "react-i18next"
import { fetchMailDelivery } from '../../../../states/containers/setting/systemSlice'

import { RootState } from '../../../../states/containers/store'
import MailDelivery from '../../../components/setting/MailDelivery'
import VideoGuide from '../../../components/common/VideoGuide'

const Index: FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const {
    login,
  } = useSelector((state: RootState) => state)

  useEffect(() => {
    if (!login.accessToken) return
    dispatch(fetchMailDelivery())
  }, [login.accessToken])

  return (
    <section className="setting_page">
      <Helmet>
        <title>{`Qasee - 設定 - 個人設定 - ${t("setting.mail_delivery.caption")}`}</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        個人設定
        &nbsp;&gt;&nbsp;
        {t("setting.mail_delivery.caption")}
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          {t("setting.mail_delivery.caption")}
          <VideoGuide
            videoId="7P3WWHVdpu0"
          />
        </h1>
      </section>
      <section className="page_description">
        <p>
          配信されるメールの受け取りを設定することができます。
        </p>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-detail">
            <MailDelivery />
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
